module.exports = __webpack_public_path__ + "images/manifestum/heartPixel.61a16b43.svg";